import triggerAnalyticsEvent from 'syf-js-utilities/helpers/triggerAnalyticsEvent';
export const timeToExpire = (expiryTime) => {
    const timeLeftMs = expiryTime.getTime() - Date.now();
    return Math.floor(timeLeftMs / 1000);
};
export const checkExpiration = (expiryTime, durationSeconds, messageType, expiringSoon, setExpiringSoon) => {
    if (timeToExpire(expiryTime) < durationSeconds && !expiringSoon) {
        setExpiringSoon(true);
        if (messageType) {
            triggerAnalyticsEvent({
                MessageType: messageType
            });
        }
    }
};
export const getExpiredDate = (expiryTime) => new Date(Date.now() + expiryTime * 1000);
